import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRoutePath } from '@bcf-v2/routes/common/app/paths/lang-route-path';
import { liveCasinoRouteI18n } from '../i18n/live-casino-route-i18n';

export function liveCasinoRoutePath(config?: TranslationConfig): string {
  return `${langRoutePath(config)}/${liveCasinoRouteI18n(config)}`;
}
